import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

export const ContainerButtonStyle = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
}));

export const DeleteButtonsStyle = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));



